import { useRef } from 'react';
import DemoBookingWidget from './DemoBookingWidget';

/**
 * Embed Demo wrapper - Browser chrome + DemoBookingWidget
 */
const EmbedDemo = ({ onJoinWaitlist }: { onJoinWaitlist: () => void }) => {
  const frameRef = useRef<HTMLDivElement>(null);

  const handleFrameClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Only focus the first interactive element if clicking on the frame background
    if (e.target === e.currentTarget || (e.target as HTMLElement).closest('[data-frame-bg]')) {
      const firstInput = frameRef.current?.querySelector<HTMLElement>('[data-testid="checkin-field"], input, button');
      firstInput?.focus();
    }
  };

  return (
    <div className="relative">
      {/* Browser chrome frame */}
      <div
        ref={frameRef}
        tabIndex={0}
        onClick={handleFrameClick}
        className="bg-neutral-100 rounded-xl border border-neutral-200 shadow-sm overflow-hidden cursor-pointer transition-colors duration-200 ease-out hover:border-neutral-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-300 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
      >
      {/* URL bar */}
      <div className="flex items-center gap-2 px-4 py-3 border-b border-neutral-200 bg-neutral-50">
        <div className="flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-neutral-300" />
          <div className="w-3 h-3 rounded-full bg-neutral-300" />
          <div className="w-3 h-3 rounded-full bg-neutral-300" />
        </div>
        <div className="flex-1 mx-4">
          <div className="bg-white rounded-md px-3 py-1.5 text-xs text-neutral-500 border border-neutral-200">
            yourwebsite.com/book
          </div>
        </div>
      </div>

      {/* Website content area */}
      <div className="bg-white p-4 md:p-6">
        {/* Simulated page header */}
        <div className="mb-4 pb-3 border-b border-neutral-100">
          <div className="h-3 w-24 bg-neutral-200 rounded mb-2" />
          <div className="h-2 w-40 bg-neutral-100 rounded" />
        </div>

        {/* The interactive booking widget */}
        <div className="max-w-[380px] mx-auto">
          <DemoBookingWidget onJoinWaitlist={onJoinWaitlist} />
        </div>
      </div>
      </div>
    </div>
  );
};

export default EmbedDemo;
